import React from "react";

interface Props {
  currencyOptions: string[];
  selectedCurrency: string | undefined;
  onChangeCurrency: (event: any) => void;
  onChangeAmount: (event: any) => void;
  amount: number;
  title: string;
  margin: string;
}

function CurrencyInput(props: Props): JSX.Element {
  const {
    currencyOptions,
    selectedCurrency,
    onChangeCurrency,
    onChangeAmount,
    amount,
    title,
    margin,
  } = props;
  return (
    <div className={`border border-grey-light flex rounded ${margin}`}>
      <div className=" w-9/12 py-2 flex flex-col ">
        <div className=" px-4 text-grey-dim text-xs ">{title}</div>

        <input
          type="number"
          className="input px-4 w-full text-lg outline-none appearance-none m-0"
          value={amount}
          // min="0"
          onChange={onChangeAmount}
        />
      </div>

      <select
        value={selectedCurrency}
        onChange={onChangeCurrency}
        className=" w-3/12 bg-grey rounded-r pl-8 flex justify-center items-center"
      >
        {currencyOptions.map((option: string) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}

export default CurrencyInput;
